module.exports = __webpack_public_path__ + "assets/incapsula.1218485e.svg";